import { createGlobalStyle } from "styled-components";

import { museoSansFont } from "theme/muiTheme";

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${props => props.theme.colors.redesign.db1};
    width: 100vw;
    max-width: 100%;
    height: ${props => (props.theme.vh ? `${props.theme.vh}px` : "100vh")};
    margin: 0;
    padding: 0;
    font-family: ${museoSansFont};

    #root {
      height: 100%;
      display: flex;
    }

    a {
      cursor: pointer;
      color: ${props => props.theme.colors.redesign.b100};
    }
    @media print {
      margin: ${props => props.theme.spacing.S_30};
    }
  }
`;
